import { render, staticRenderFns } from "./ExpiredPayments.vue?vue&type=template&id=167d247b&scoped=true"
import script from "./ExpiredPayments.vue?vue&type=script&lang=js"
export * from "./ExpiredPayments.vue?vue&type=script&lang=js"
import style0 from "./ExpiredPayments.vue?vue&type=style&index=0&id=167d247b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d247b",
  null
  
)

export default component.exports